import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { StickyContainer } from "react-sticky";

import Nav from "./Nav";
import Step1 from "../../Step1";
import StyleChoice from "../../WizardStyleChoice";
import LayoutChoice from "../../WizardLayoutChoice";
import Step4 from "../../Step4";
import Step5 from "../../Step5";
import Footer from "./Footer";

import "./Wizard.css";

export interface WizardProps {
  navItems: JSX.Element[];
}

const Wizard = (props: WizardProps) => (
  <div className="wizard-page">
    <StickyContainer>
      <header>
        <Nav>{props.navItems}</Nav>
      </header>
      <main>
        <section className="wizard">
          <div className="wizard__container">
            <div className="wizard__content">
              <Switch>
                <Route path="/wizard/step-1" component={Step1} />
                <Route path="/wizard/step-2" component={LayoutChoice} />
                <Route path="/wizard/step-3" component={StyleChoice} />
                <Route path="/wizard/step-4" component={Step4} />
                <Route path="/wizard/step-5" component={Step5} />
              </Switch>
            </div>
            <div className="wizard__footer">
              <Route
                path="/wizard/:subpath(step-1|step-2|step-3)"
                component={Footer}
              />
            </div>
          </div>
        </section>
      </main>
    </StickyContainer>
  </div>
);

export default Wizard;



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/Wizard.tsx